<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">系统配置</div>

    <div class="content-wrapper">
      <el-table :data="listData">
        <el-table-column label="名称" prop="moduleId" width="210">
          <template scope="{ row }">{{ handleTitle(row) }}</template>
        </el-table-column>
        <el-table-column label="内容">
          <template scope="{ row }">
            <div
              v-if="isCampusShieldRow(row)"
              class="credit-score-campus-content"
              style="white-space: pre-line"
            >
              <template v-if="hasAlipayFaceConfig(row)">
                <span>{{ campusShieldFaceText(row) }}</span>
                <br />
              </template>
              <template v-if="campusShieldList(row).length">
                <span>{{ campusShieldShortText(row) }}</span>
                <template v-if="campusShieldList(row).length > 3">
                  <span class="split">|</span>
                  <span
                    class="link"
                    @click="
                      openYuedongDialog(
                        campusShieldDialogTitle(row),
                        campusShieldDialogRows(row)
                      )
                    "
                    >更多</span
                  >
                </template>
              </template>
              <span v-else>{{ campusShieldEmptyText(row) }}</span>
            </div>
            <span
              v-else-if="row.resKey !== 'YUEDONG_AD_CONFIG_KEY'"
              style="white-space: pre-line"
              >{{ handleContent(row) }}</span
            >
            <div v-else class="yuedong-content">
              <div
                v-if="
                  yuedongData(row) &&
                  yuedongData(row).systemBlock &&
                  yuedongData(row).systemBlock.length
                "
              >
                屏蔽总开关：{{ yuedongSystemText(row) }}
              </div>
              <div>
                版本号屏蔽：
                <template v-if="yuedongVersionList(row).length > 10">
                  <span
                    class="link"
                    @click="
                      openYuedongDialog(
                        '版本号屏蔽',
                        yuedongVersionDialogRows(row)
                      )
                    "
                    >{{ yuedongVersionList(row).length }}</span
                  >
                </template>
                <template v-else>{{ yuedongVersionText(row) }}</template>
              </div>
              <div v-if="yuedongData(row)">
                应用校区：{{ yuedongCampusTypeText(row) }}（{{
                  yuedongCampusDialogTitle(row)
                }}：<template v-if="yuedongCampusNameList(row).length > 10"
                  ><span
                    class="link"
                    @click="
                      openYuedongDialog(
                        yuedongCampusDialogTitle(row),
                        yuedongCampusDialogRows(row)
                      )
                    "
                    >{{ yuedongCampusNameList(row).length }}</span
                  ></template
                ><template v-else>{{ yuedongCampusNamesText(row) }}</template
                >）
              </div>
              <div v-else>{{ row.resValue }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template scope="{ row }">
            <el-switch
              v-if="isBarrierFreeRow(row)"
              :value="row.resValue === 1 || row.resValue === '1'"
              :disabled="barrierFreeSaving"
              @change="toggleBarrierFree(row, $event)"
            ></el-switch>
            <el-button v-else type="text" @click="clickEditing(row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <PhoneTypeShield
      ref="phoneTypeShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </PhoneTypeShield>

    <PhoneCodeShield
      ref="phoneCodeShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </PhoneCodeShield>

    <SkipPhoneBinding
      ref="skipPhoneBinding"
      :type-options="phoneTypeOptions"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </SkipPhoneBinding>

    <SchoolOpenGiftPack
      ref="schoolOpenGiftPack"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </SchoolOpenGiftPack>

    <InfoFlowAdShield
      ref="infoFlowAdShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </InfoFlowAdShield>

    <LuFundCampusShield
      ref="luFundCampusShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      :campus-data-source="campusDataSource"
      @refresh="queryList"
    >
    </LuFundCampusShield>

    <CreditScoreCampusShield
      ref="creditScoreCampusShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      :campus-data-source="campusDataSource"
      @refresh="queryList"
    >
    </CreditScoreCampusShield>

    <PhysicalReportCampusShield
      ref="physicalReportCampusShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      :campus-data-source="campusDataSource"
      @refresh="queryList"
    >
    </PhysicalReportCampusShield>

    <DebugUser
      ref="debugUser"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </DebugUser>

    <FengXiangTag
      ref="fengXiangTag"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      :campus-data-source="campusDataSource"
      @refresh="queryList"
    >
    </FengXiangTag>

    <DigitalYuedongAdShield
      ref="digitalYuedongAdShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      :campus-data-source="campusDataSource"
      @refresh="queryList"
    >
    </DigitalYuedongAdShield>

    <JuTuiAdShield
      ref="juTuiAdShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      @refresh="queryList"
    >
    </JuTuiAdShield>

    <AdVersionShield
      ref="adVersionShield"
      :dialog-title="editDialog.title"
      :data-source="editDialog.data"
      :campus-data-source="campusDataSource"
      @refresh="queryList"
    >
    </AdVersionShield>

    <el-dialog
      :title="yuedongDialog.title"
      v-model="yuedongDialog.visible"
      :modal-append-to-body="false"
      size="tiny"
    >
      <el-input
        v-model="yuedongDialog.keyword"
        placeholder="搜索"
        clearable
        style="margin-bottom: 12px"
      ></el-input>
      <div class="yuedong-dialog-list">
        <div
          v-for="(item, i) in yuedongDialogFiltered()"
          :key="i"
          class="yuedong-dialog-item"
        >
          {{ item.label }}
        </div>
        <div
          v-if="!yuedongDialogFiltered().length"
          class="yuedong-dialog-empty"
        >
          无数据
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PhoneTypeShield from "./Components/PhoneTypeShield.vue";
import PhoneCodeShield from "./Components/PhoneCodeShield.vue";
import SkipPhoneBinding from "./Components/SkipPhoneBinding.vue";
import SchoolOpenGiftPack from "./Components/SchoolOpenGiftPack.vue";
import InfoFlowAdShield from "./Components/InfoFlowAdShield.vue";
import LuFundCampusShield from "./Components/LuFundCampusShield.vue";
import CreditScoreCampusShield from "./Components/CreditScoreCampusShield.vue";
import PhysicalReportCampusShield from "./Components/PhysicalReportCampusShield.vue";
import DebugUser from "./Components/DebugUser.vue";
import FengXiangTag from "./Components/FengXiangTag.vue";
import DigitalYuedongAdShield from "./Components/DigitalYuedongAdShield.vue";
import JuTuiAdShield from "./Components/JuTuiAdShield.vue";
import AdVersionShield from "./Components/AdVersionShield.vue";

export default {
  components: {
    PhoneTypeShield,
    PhoneCodeShield,
    SkipPhoneBinding,
    SchoolOpenGiftPack,
    InfoFlowAdShield,
    LuFundCampusShield,
    CreditScoreCampusShield,
    PhysicalReportCampusShield,
    DebugUser,
    FengXiangTag,
    DigitalYuedongAdShield,
    JuTuiAdShield,
    AdVersionShield,
  },

  data() {
    return {
      loading: false,
      campusDataSource: [], // 校区数据源
      yuedongDialog: {
        visible: false,
        title: "",
        keyword: "",
        list: [],
      },
      paramData: [
        {
          title: "粉象口令植入",
          resKey: "FENG_XIANG_TAG",
          tag: "FENG_XIANG_TAG",
          index: 18,
        },
        {
          title: "跳过手机绑定开关",
          resKey: "SKIP_BIND_PHONE_TAG",
          tag: "BASIC_CONFIG_TAG",
          index: 2,
        },
        {
          title: "关闭会员入口",
          resKey: "PRIVILEGE_BUY_CONFIG_KEY",
          tag: "APP_HOME_CONFIG_TAG",
          index: 3,
        },
        {
          title: "后台传感器权限屏蔽",
          resKey: "OPEN_BACKGROUND_SENSOR",
          tag: "APP_HOME_CONFIG_TAG",
          index: 4,
        },
        {
          title: "陆基金根据系统屏蔽",
          resKey: "LUFUND_SHIELD_CONFIG_VERSION",
          tag: "PARTNER_CONFIG_TAG",
          index: 7,
        },
        {
          title: "陆基金根据设备屏蔽",
          resKey: "LUFUND_SHIELD_CONFIG_DEVICE",
          tag: "PARTNER_CONFIG_TAG",
          index: 9,
        },
        {
          title: "首页信息流广告版本号屏蔽",
          resKey: "HOME_INFORMATION_AD_SHIELD",
          tag: "BASIC_CONFIG_TAG",
          index: 10,
        },
        {
          title: "摩西屏蔽",
          resKey: "MO_XI_SHIELD",
          tag: "APP_HOME_CONFIG_TAG",
          index: 11,
        },
        {
          title: "移动广告",
          resKey: "AD_TYPE_CONFIG_OSTYPE_KEY",
          tag: "APP_HOME_CONFIG_TAG",
          index: 12,
        },
        {
          title: "数字悦动广告",
          resKey: "YUEDONG_AD_CONFIG_KEY",
          tag: "YUEDONG_AD_CONFIG_TAG",
          index: 19,
        },
        // {
        //   title: "聚推广告",
        //   resKey: "JUTUI_AD_SHIELD",
        //   tag: "BASIC_CONFIG_TAG",
        //   index: 24,
        // },
        {
          title: "陆基金根据校区屏蔽",
          resKey: "LUFUND_SHIELD_CONFIG_ROOTUNID",
          tag: "PARTNER_CONFIG_TAG",
          index: 13,
        },
        {
          title: "学期信用分根据校区屏蔽",
          baseTitle: "学期信用分", // 名称按 isAll 动态拼接「根据校区屏蔽 / 根据校区生效」
          resKey: "CREDIT_SCORE_UNIDS_V70390",
          tag: "CREDIT_SCORE_CONFIG_V70390_TAG",
          index: 22,
        },
        {
          title: "学生端体测报告配置根据校区屏蔽",
          baseTitle: "学生端体测报告配置",
          resKey: "NEW_PHYSICAL_REPORT_CAMPUS",
          tag: "NEW_PHYSICAL_REPORT_CONFIG_TAG",
          index: 23,
        },
        {
          title: "序言泽广告",
          resKey: "XYZ_AD_SHIELD",
          tag: "BASIC_CONFIG_TAG",
          index: 14,
        },
        {
          title: "一键登录屏蔽",
          resKey: "ONE_CLICK_LOGIN_CONFIG_KEY",
          tag: "PRE_LOGIN_CONFIG_TAG",
          index: 15,
        },
        {
          title: "天目（悬浮）广告屏蔽",
          resKey: "TIANMU_AD_SHIELD",
          tag: "BASIC_CONFIG_TAG",
          index: 16,
        },
        {
          title: "跑步记录≤2次屏蔽广告策略",
          resKey: "AD_VERSION_RUN_SHIELD",
          tag: "AD_VERSION_RUN_TAG",
          index: 20,
        },
        {
          title: "Debug用户",
          resKey: "DEBUG_USER_KEY",
          tag: "APP_HOME_CONFIG_TAG",
          index: 17,
        },
        {
          title: "无障碍",
          resKey: "ALL_SHIELD_BARRIER_FREE_KEY",
          tag: "BASIC_CONFIG_TAG",
          index: 21,
        },
      ],
      phoneTypeOptions: [
        { label: "预发环境", value: "0" },
        { label: "sportworld", value: "000" },
        { label: "qh360", value: "001" },
        { label: "xiaomi", value: "002" },
        { label: "baidu", value: "004" },
        { label: "tencent", value: "007" },
        { label: "anzhi", value: "008" },
        { label: "meizu", value: "009" },
        { label: "mumayi", value: "010" },
        { label: "huawei", value: "011" },
        { label: "lenovo", value: "012" },
        { label: "jinli", value: "013" },
        { label: "oppo", value: "014" },
        { label: "sogou", value: "015" },
        { label: "vivo", value: "029" },
        { label: "google", value: "030" },
      ],
      listData: [],
      editDialog: {
        title: "",
        data: {},
      },
      // 无障碍屏蔽开关保存中（防止连续点击）
      barrierFreeSaving: false,
    };
  },

  mounted() {
    this.queryList();
    this.queryAllCampus();
  },

  methods: {
    // 查询所有校区
    queryAllCampus() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
        method: "GET",
      })
        .then((res) => {
          if (res.body.data && res.body.data.length) {
            this.campusDataSource = res.body.data.map((item) => ({
              label: item.name,
              value: item.unid,
            }));
            // 校区数据加载完成后，强制更新列表显示
            this.$forceUpdate();
          } else {
            this.campusDataSource = [];
          }
        })
        .catch((error) => {
          console.log("陆基金校区屏蔽-获取校区列表失败:", error);
          this.campusDataSource = [];
        });
    },

    // 获取列表
    queryList() {
      this.loading = true;
      const param = this.paramData.map((item) => ({
        resKey: item.resKey,
        tag: item.tag,
      }));
      this.$http({
        url: this.$util.domain + "/adminapi/v1/tools/config/list",
        method: "POST",
        body: JSON.stringify(param),
      })
        .then((res) => {
          this.listData = res.body.data || [];
          const fengXiangItem = this.listData.find(
            (item) =>
              item.resKey === "FENG_XIANG_TAG" && item.tag === "FENG_XIANG_TAG"
          );
          console.log("FENG_XIANG_TAG-queryList-responseBody:", res.body);
          console.log("FENG_XIANG_TAG-queryList-currentItem:", fengXiangItem);
        })
        .catch((error) => {
          this.listData = [];
          this.$util.errorMsg("获取详情信息失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 编辑
    clickEditing(row) {
      const key = row.resKey + row.tag;
      const resultIndex = this.paramData.findIndex(
        (item) => item.resKey + item.tag === key
      );
      if (resultIndex !== -1) {
        this.editDialog.title = this.paramData[resultIndex].title;
        this.editDialog.data = row;
        this.$nextTick(() => {
          const index = this.paramData[resultIndex].index;
          if ([0, 3, 6, 7, 12].includes(index)) {
            this.$refs.phoneTypeShield.clickEdit();
          } else if ([1, 4, 8, 9].includes(index)) {
            this.$refs.phoneCodeShield.clickEdit();
          } else if (index === 2) {
            this.$refs.skipPhoneBinding.clickEdit();
          } else if (index === 5) {
            this.$refs.schoolOpenGiftPack.clickEdit();
          } else if ([10, 11, 14, 15, 16].includes(index)) {
            this.$refs.infoFlowAdShield.clickEdit();
          } else if (index === 13) {
            this.$refs.luFundCampusShield.clickEdit();
          } else if (index === 22) {
            this.$refs.creditScoreCampusShield.clickEdit();
          } else if (index === 23) {
            this.$refs.physicalReportCampusShield.clickEdit();
          } else if (index === 17) {
            this.$refs.debugUser.clickEdit();
          } else if (index === 18) {
            this.$refs.fengXiangTag.clickEdit(row);
          } else if (index === 19) {
            this.$refs.digitalYuedongAdShield.clickEdit();
          } else if (index === 24) {
            this.$refs.juTuiAdShield.clickEdit();
          } else if (index === 20) {
            this.$refs.adVersionShield.clickEdit();
          }
        });
      }
    },

    // 处理标题
    handleTitle(row) {
      const param = this.paramData.find(
        (item) => item.tag === row.tag && item.resKey === row.resKey
      );
      if (!param) {
        return "";
      }
      if (this.isCampusShieldRow(row)) {
        return param.baseTitle || param.title;
        // return (
        //   baseTitle +
        //   (this.campusShieldIsAll(row) ? "根据校区屏蔽" : "根据校区生效")
        // );
      }
      return param.title || "";
    },

    // 处理内容
    handleContent(row) {
      if (!row.resValue) {
        return "";
      }
      const key = row.resKey + row.tag;
      const resultIndex = this.paramData.findIndex(
        (item) => item.resKey + item.tag === key
      );
      let index = -1;
      if (resultIndex !== -1) {
        index = this.paramData[resultIndex].index;
      }
      if ([0, 3, 6, 7, 12].includes(index)) {
        return this.handlePhoneSystem(row.resValue.split(","));
      } else if ([1, 4, 8, 9].includes(index)) {
        return row.resValue
          .split(",")
          .map((item) => item)
          .join(", ");
      } else if (index === 2) {
        return this.handlePhoneType(row.resValue.split(","));
      } else if (index === 5) {
        const resValue = JSON.parse(row.resValue);
        return Object.keys(resValue)
          .map((item) => {
            return item + ":" + decodeURIComponent(resValue[item]);
          })
          .join("\n");
      } else if ([10, 11, 14, 15, 16].includes(index)) {
        return this.handleMultipleShield(JSON.parse(row.resValue));
      } else if (index === 13) {
        return this.handleLuFundCampusShield(row.resValue);
      } else if (index === 17) {
        return this.handleDebugUser(row.resValue);
      } else if (index === 18) {
        return this.handleFengXiangTag(row.resValue);
      } else if (index === 19) {
        return this.handleDigitalYuedongAd(row.resValue);
      } else if (index === 24) {
        return this.handleJuTuiAd(row.resValue);
      } else if (index === 20) {
        return this.handleAdVersionShield(row.resValue);
      } else if (index === 21) {
        return this.handleBarrierFree(row.resValue);
      }
      return row.resValue;
    },

    // 是否「校区屏蔽」类配置行（内容列特殊渲染：人脸文案 + 校区列表，超出3个折叠）
    // 覆盖：学期信用分根据校区屏蔽、学生端体测报告配置
    isCampusShieldRow(row) {
      return (
        (row.resKey === "CREDIT_SCORE_UNIDS_V70390" &&
          row.tag === "CREDIT_SCORE_CONFIG_V70390_TAG") ||
        (row.resKey === "NEW_PHYSICAL_REPORT_CAMPUS" &&
          row.tag === "NEW_PHYSICAL_REPORT_CONFIG_TAG")
      );
    },

    // 该行是否含「屏蔽已开启支付宝人脸验证的学校」配置（仅学期信用分有此字段）
    hasAlipayFaceConfig(row) {
      return (
        row.resKey === "CREDIT_SCORE_UNIDS_V70390" &&
        row.tag === "CREDIT_SCORE_CONFIG_V70390_TAG"
      );
    },

    // 解析校区屏蔽配置数据
    campusShieldData(row) {
      const resValue = row && row.resValue;
      if (!resValue || resValue === "") {
        return { isAll: 1, disableAlipayFace: 0, unids: [] };
      }
      try {
        const data = JSON.parse(resValue);
        return {
          isAll: Number(data.isAll) === 0 ? 0 : 1,
          disableAlipayFace: Number(data.disableAlipayFace) === 1 ? 1 : 0,
          unids: Array.isArray(data.unids) ? data.unids : [],
        };
      } catch (error) {
        console.log("校区屏蔽-解析数据失败:", error);
        return { isAll: 1, disableAlipayFace: 0, unids: [] };
      }
    },

    // 是否全量校区
    campusShieldIsAll(row) {
      return this.campusShieldData(row).isAll === 1;
    },

    // 人脸验证屏蔽文案
    campusShieldFaceText(row) {
      const data = this.campusShieldData(row);
      return data.disableAlipayFace === 1
        ? "已屏蔽已开启支付宝人脸验证的学校"
        : "未屏蔽已开启支付宝人脸验证的学校";
    },

    // 校区列表：空态文案
    campusShieldEmptyText(row) {
      return this.campusShieldIsAll(row) ? "无屏蔽校区" : "无生效校区";
    },

    // 校区列表：弹窗标题
    campusShieldDialogTitle(row) {
      return this.campusShieldIsAll(row) ? "屏蔽校区" : "生效校区";
    },

    // 解析校区列表（[{label,value}]）
    campusShieldList(row) {
      const data = this.campusShieldData(row);
      return data.unids.map((unid) => {
        const campus = this.campusDataSource.find(
          (item) =>
            String(item.value) === String(unid) || item.value === Number(unid)
        );
        return {
          label: campus ? `${campus.label}（${unid}）` : `${unid}（${unid}）`,
          value: unid,
        };
      });
    },

    // 校区列表：内容列短文本（最多展示3个）
    campusShieldShortText(row) {
      const list = this.campusShieldList(row);
      if (!list.length) {
        return "";
      }
      return list
        .slice(0, 3)
        .map((item) => item.label)
        .join(", ");
    },

    // 校区列表：弹窗行数据
    campusShieldDialogRows(row) {
      return this.campusShieldList(row).map((item) => ({
        label: item.label,
      }));
    },

    // 是否「无障碍屏蔽」配置行（操作列展示 switch）
    isBarrierFreeRow(row) {
      return (
        row.resKey === "ALL_SHIELD_BARRIER_FREE_KEY" &&
        row.tag === "BASIC_CONFIG_TAG"
      );
    },

    // 无障碍屏蔽：内容列展示文案（0 关闭 / 1 开启）
    handleBarrierFree(resValue) {
      return resValue === 1 || resValue === "1" ? "开启" : "关闭";
    },

    // 无障碍屏蔽：switch 切换回写（0 关闭 / 1 开启）
    toggleBarrierFree(row, val) {
      const newVal = val ? "1" : "0";
      if (row.resValue === newVal) return;
      this.barrierFreeSaving = true;
      const param = {
        tag: row.tag,
        key: row.resKey,
        value: newVal,
      };
      this.$http({
        url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
        method: "POST",
        dataType: "json",
        body: JSON.stringify(param),
      })
        .then((res) => {
          if (res.body && res.body.error === 10000) {
            row.resValue = newVal;
            this.$message.success(
              newVal === "1" ? "已开启无障碍屏蔽" : "已关闭无障碍屏蔽"
            );
          } else {
            this.$util.errorMsg((res.body && res.body.message) || "操作失败");
          }
        })
        .catch((err) => {
          console.log("无障碍屏蔽-保存失败:", err);
          this.$util.errorMsg("操作失败");
        })
        .finally(() => {
          this.barrierFreeSaving = false;
        });
    },

    // 处理手机系统及版本号
    handlePhoneSystem(list) {
      if (!list || list.length === 0) {
        return "";
      }
      return list
        .map((item) => {
          const tmpArr = item.split(":");
          const type = tmpArr[0] || "";
          const version = tmpArr[1] || "";
          let typeLabel = "";
          if (type === "0") {
            typeLabel = "Android";
          } else if (type === "1") {
            typeLabel = "iOS";
          } else if (type === "2") {
            typeLabel = "HarmonyOS";
          }
          return (typeLabel ? typeLabel : type) + ":" + version;
        })
        .join(", ");
    },

    // 处理手机类型及版本号
    handlePhoneType(list) {
      if (!list || list.length === 0) {
        return "";
      }
      return list
        .map((item) => {
          const tmpArr = item.split(":");
          const type = tmpArr[0] || "";
          const version = tmpArr[1] || "";
          const optionIndex = this.phoneTypeOptions.findIndex(
            (option) => option.value === type
          );
          if (optionIndex != -1) {
            return this.phoneTypeOptions[optionIndex].label + ":" + version;
          }
          return type + ":" + version;
        })
        .join(", ");
    },

    // 处理多类型屏蔽
    handleMultipleShield(resValue) {
      let result = "";
      if (resValue.all) {
        const value = resValue.all
          .map((item) => {
            const type = item.split(":")[0];
            if (type === "0") {
              return "Android";
            } else if (type === "1") {
              return "iOS";
            } else if (type === "2") {
              return "HarmonyOS";
            }
            return type;
          })
          .join(", ");
        result += "总屏蔽：" + value + "\n";
      }
      if (resValue.device) {
        result += "设备：" + resValue.device.join(", ") + "\n";
      }
      if (resValue.version) {
        result += "版本：" + this.handlePhoneSystem(resValue.version);
      }
      return result;
    },

    // 处理陆基金校区屏蔽
    handleLuFundCampusShield(resValue) {
      console.log("陆基金校区屏蔽-处理数据:", resValue);
      console.log(
        "陆基金校区屏蔽-校区数据源长度:",
        this.campusDataSource.length
      );

      if (!resValue || typeof resValue !== "string" || resValue === "0") {
        return "";
      }

      // 解析校区ID列表，格式如 "90000,90001,90002" 或 "900000"
      const campusIds = resValue
        .split(",")
        .filter((id) => id && id.trim() && id !== "0");
      console.log("陆基金校区屏蔽-解析的校区ID:", campusIds);

      if (campusIds.length === 0) {
        return "";
      }

      // 如果校区数据源还没有加载完成，先显示ID
      if (!this.campusDataSource || this.campusDataSource.length === 0) {
        return "已屏蔽校区ID: " + campusIds.join(", ");
      }

      // 根据校区ID获取校区名称
      const campusNames = campusIds.map((campusId) => {
        // 尝试字符串和数字两种类型匹配
        const campusData = this.campusDataSource.find(
          (item) => item.value === campusId || item.value === parseInt(campusId)
        );
        console.log(`陆基金校区屏蔽-查找校区ID ${campusId}:`, campusData);
        return campusData ? campusData.label : campusId;
      });

      console.log("陆基金校区屏蔽-最终校区名称:", campusNames);
      return campusNames.join(", ");
    },

    // 处理 Debug 用户列表展示
    handleDebugUser(resValue) {
      if (!resValue || resValue === "") {
        return "";
      }
      try {
        const data = JSON.parse(resValue);
        if (data.uid && Array.isArray(data.uid) && data.uid.length > 0) {
          return data.uid.join(", ");
        }
      } catch (e) {
        console.log("Debug用户-解析展示失败:", e);
      }
      return "";
    },

    // 处理粉象口令植入展示
    handleFengXiangTag(resValue) {
      if (!resValue || resValue === "") {
        return "";
      }
      try {
        const data = JSON.parse(resValue);
        const channelCodeMap = {
          淘宝: "TB-YDSJ",
          "TB-YDSJ": "TB-YDSJ",
          淘宝闪购: "SG-YDSJ",
          饿了么: "SG-YDSJ",
          "SG-YDSJ": "SG-YDSJ",
          唯品会: "VIP-YDSJ",
          "VIP-YDSJ": "VIP-YDSJ",
          京东老鞋: "JD-E_COMMERCE",
          京东电商: "JD-E_COMMERCE",
          "JD-E_COMMERCE": "JD-E_COMMERCE",
          京东外卖: "JD-FOOD_DELIVERY",
          "JD-FOOD_DELIVERY": "JD-FOOD_DELIVERY",
          美团外卖: "MT-FOOD_DELIVERY",
          "MT-FOOD_DELIVERY": "MT-FOOD_DELIVERY",
        };
        const channelLabelMap = {
          "TB-YDSJ": "淘宝",
          "SG-YDSJ": "饿了么",
          "VIP-YDSJ": "唯品会",
          "JD-E_COMMERCE": "京东电商",
          "JD-FOOD_DELIVERY": "京东外卖",
          "MT-FOOD_DELIVERY": "美团外卖",
        };
        const switchOnlyChannels = ["TB-YDSJ", "SG-YDSJ", "VIP-YDSJ"];
        const channelDesc = Array.isArray(data.channels)
          ? data.channels
              .map((item) => {
                const channelCode =
                  channelCodeMap[item.channel] || item.channel;
                const channelName =
                  channelLabelMap[channelCode] || item.channel;
                const openStatus = Number(item.isOpen) === 1 ? "开启" : "关闭";
                const showCode =
                  !switchOnlyChannels.includes(channelCode) && !!item.code;
                const codeText = showCode ? `，口令：${item.code}` : "";
                return `${channelName}（${openStatus}${codeText}）`;
              })
              .join("\n")
          : "";
        const osDesc = Array.isArray(data.osType)
          ? data.osType
              .map((item) => {
                if (Number(item) === 0) {
                  return "Android";
                } else if (Number(item) === 1) {
                  return "iOS";
                } else if (Number(item) === 2) {
                  return "HarmonyOS";
                }
                return String(item);
              })
              .join(", ")
          : "";
        let campusDesc = "全部校区";
        if (Number(data.allUnidFlag) === 1) {
          const campusNames = Array.isArray(data.unidList)
            ? data.unidList.map((unid) => {
                const campus = this.campusDataSource.find(
                  (item) => item.value === unid || item.value === Number(unid)
                );
                return campus ? campus.label : String(unid);
              })
            : [];
          campusDesc = campusNames.length ? campusNames.join(", ") : "部分校区";
        }
        return `渠道：\n${channelDesc}\n手机系统：${osDesc}\n适用校区：${campusDesc}`;
      } catch (error) {
        console.log("粉象口令植入-解析展示失败:", error);
        return "";
      }
    },

    // 处理聚推广告展示（结构同数字悦动广告，但无应用校区）
    handleJuTuiAd(resValue) {
      if (!resValue || resValue === "") {
        return "";
      }
      try {
        const data = JSON.parse(resValue);
        let result = "";
        if (data.systemBlock && data.systemBlock.length) {
          result +=
            "屏蔽总开关：" +
            data.systemBlock.map((t) => this.getOsLabel(t)).join("、") +
            "\n";
        }
        if (data.versionBlock && data.versionBlock.length) {
          const versions = data.versionBlock
            .map(
              (item) =>
                this.getOsLabel(item.osType) + ":" + (item.version || "")
            )
            .join("，");
          result += "版本号屏蔽：" + versions;
        }
        return result;
      } catch (e) {
        console.log("聚推广告-解析展示失败:", e);
        return resValue;
      }
    },

    // 处理数字悦动广告展示
    handleDigitalYuedongAd(resValue) {
      if (!resValue || resValue === "") {
        return "";
      }
      try {
        const data = JSON.parse(resValue);
        let result = "";
        if (data.systemBlock && data.systemBlock.length) {
          result +=
            "屏蔽总开关：" +
            data.systemBlock.map((t) => this.getOsLabel(t)).join("、") +
            "\n";
        }
        if (data.versionBlock && data.versionBlock.length) {
          const versions = data.versionBlock
            .map(
              (item) =>
                this.getOsLabel(item.osType) + ":" + (item.version || "")
            )
            .join("，");
          result += "版本号屏蔽：" + versions + "\n";
        }
        if (data.campusType === "1") {
          const blockNames = this.getCampusNames(data.unidList);
          result +=
            "应用校区：全量" +
            (blockNames
              ? "（屏蔽校区：" + blockNames + "）"
              : "（不屏蔽校区）");
        } else if (data.campusType === "2") {
          const effectNames = this.getCampusNames(data.unidList);
          result +=
            "应用校区：部分（生效校区：" + (effectNames || "未设置") + "）";
        }
        return result;
      } catch (e) {
        console.log("数字悦动广告-解析展示失败:", e);
        return resValue;
      }
    },

    // 处理广告按版本屏蔽展示
    handleAdVersionShield(resValue) {
      if (!resValue || resValue === "") {
        return "";
      }
      try {
        const data = JSON.parse(resValue);
        if (!data.enableVersionShield) {
          return "策略未开启";
        }

        if (data.versionBlock && data.versionBlock.length) {
          const versions = data.versionBlock
            .map(
              (item) =>
                this.getOsLabel(item.osType) + ":" + (item.version || "")
            )
            .join(",");
          return "版本号：" + versions;
        }
        return "全部版本生效";
      } catch (e) {
        console.log("广告按版本屏蔽-解析展示失败:", e);
        return resValue;
      }
    },

    // 手机系统编码转名称（兼容数字/字符串）
    getOsLabel(type) {
      const t = String(type);
      if (t === "0") return "Android";
      if (t === "1") return "iOS";
      if (t === "2") return "HarmonyOS";
      return type;
    },

    // 校区ID列表转名称（兼容数字/字符串）
    getCampusNames(ids) {
      if (!ids || !ids.length) {
        return "";
      }
      if (!this.campusDataSource || !this.campusDataSource.length) {
        return ids.join("、");
      }
      return ids
        .map((id) => {
          const c = this.campusDataSource.find(
            (item) => item.value === id || item.value === Number(id)
          );
          return c ? c.label : id;
        })
        .join("、");
    },

    // ===== 数字悦动广告：列表结构化展示 + 超长折叠弹窗 =====
    // 解析该行 JSON（失败返回 null）
    yuedongData(row) {
      if (!row.resValue) return null;
      try {
        return JSON.parse(row.resValue);
      } catch (e) {
        return null;
      }
    },
    // 屏蔽总开关文本
    yuedongSystemText(row) {
      const d = this.yuedongData(row);
      if (!d || !d.systemBlock || !d.systemBlock.length) return "";
      return d.systemBlock.map((t) => this.getOsLabel(t)).join("、");
    },
    // 版本号屏蔽：转换为字符串数组
    yuedongVersionList(row) {
      const d = this.yuedongData(row);
      if (!d || !d.versionBlock || !d.versionBlock.length) return [];
      return d.versionBlock.map(
        (item) => this.getOsLabel(item.osType) + "：" + (item.version || "")
      );
    },
    // 版本号屏蔽：短列表直接拼接展示
    yuedongVersionText(row) {
      return this.yuedongVersionList(row).join("，");
    },
    // 版本号屏蔽：弹窗行（可搜索）
    yuedongVersionDialogRows(row) {
      return this.yuedongVersionList(row).map((t) => ({ label: t }));
    },
    // 应用校区范围文案
    yuedongCampusTypeText(row) {
      const d = this.yuedongData(row);
      if (!d) return "";
      if (d.campusType === "1") return "全量";
      if (d.campusType === "2") return "部分";
      return "";
    },
    // 校区弹窗标题（屏蔽校区 / 生效校区）
    yuedongCampusDialogTitle(row) {
      const d = this.yuedongData(row);
      if (!d) return "";
      return d.campusType === "1" ? "屏蔽校区" : "生效校区";
    },
    // 校区名列表（已解析中文）
    yuedongCampusNameList(row) {
      const d = this.yuedongData(row);
      if (!d || !d.unidList || !d.unidList.length) return [];
      const names = this.getCampusNames(d.unidList);
      if (!names) return [];
      return names.split("、").filter(Boolean);
    },
    // 校区名短列表直接拼接（空态保留原语义）
    yuedongCampusNamesText(row) {
      const list = this.yuedongCampusNameList(row);
      if (!list.length) {
        const d = this.yuedongData(row);
        if (d && d.campusType === "1") return "不屏蔽校区";
        if (d && d.campusType === "2") return "未设置";
        return "";
      }
      return list.join("、");
    },
    // 校区弹窗行（可搜索）
    yuedongCampusDialogRows(row) {
      return this.yuedongCampusNameList(row).map((t) => ({ label: t }));
    },
    // 打开折叠弹窗
    openYuedongDialog(title, rows) {
      this.yuedongDialog.title = title;
      this.yuedongDialog.list = rows || [];
      this.yuedongDialog.keyword = "";
      this.yuedongDialog.visible = true;
    },
    // 弹窗内按关键词过滤（不区分大小写）
    yuedongDialogFiltered() {
      const kw = (this.yuedongDialog.keyword || "").trim().toLowerCase();
      const list = this.yuedongDialog.list || [];
      if (!kw) return list;
      return list.filter(
        (item) => (item.label || "").toLowerCase().indexOf(kw) !== -1
      );
    },
  },
};
</script>

<style scoped>
.content-wrapper {
  margin-bottom: 20px;
}

/* 数字悦动广告：超长列表折叠为可点击下划线 */
.yuedong-content > div {
  margin: 2px 0;
}
.link {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
}
.credit-score-campus-content .split {
  margin: 0 8px;
  color: #c0c4cc;
}
.yuedong-dialog-list {
  max-height: 360px;
  overflow: auto;
}
.yuedong-dialog-item {
  padding: 6px 4px;
  border-bottom: 1px solid #f0f0f0;
}
.yuedong-dialog-empty {
  padding: 20px;
  text-align: center;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// SystemConfig.vue?1757e42a